var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("group:title"),_c('div',{staticClass:"grid col-span-2 gap-4 sm:grid-cols-2"},_vm._l((_vm.components),function(c){return _c(c.name,{key:c.key,tag:"component",attrs:{"controls":_vm.controls,"value":c.value,"checked":c.value,"http-errors":c.errors},on:{"input:field":function($event){return _vm.onInput($event, c.key)}}})}),1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }